import { jsx as _jsx } from "react/jsx-runtime";
const PencilFilled = () => (_jsx("svg", Object.assign({ viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "m39.25 12 12.2 12.21-30.9 30.9-12.19-12.25zm21.47-3-5.45-5.42a5.39 5.39 0 0 0 -7.63 0l-5.21 5.21 12.2 12.21 6.08-6.08a4.16 4.16 0 0 0 0-5.88zm-58.72 51a1.39 1.39 0 0 0 1 1.68 1.34 1.34 0 0 0 .63 0l13.6-3.29-12.18-12.22z" }) })));
PencilFilled.iconName = "pencilfilled";
PencilFilled.iconCategory = "Misc - Deprecated";
PencilFilled.deprecated = true;
export default PencilFilled;
